import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import SidebarPageLayout from '../../components/layout/SidebarPageLayout';

function ReleaseNotes() {

  useEffect(() => {
    document.title = "Vivosol Plant Performance Insights Hub | Help / Release Notes";
  }, []);

  return (
    <SidebarPageLayout>
      <div className="content p-5">
        <h1>Release Notes</h1>
      </div>
    </SidebarPageLayout>
  );
}

export default ReleaseNotes;
